import { SVGProps } from "react"

export function BigBlueIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      viewBox="0 0 353 342"
      height="150"
      {...props}
    >
      <style>{`.s0 { fill: #232426 }`}</style>
      <path
        id="Layer"
        fillRule="evenodd"
        className="s0"
        d="M142.216 18.71c6.766 6.418 9.951 13.798 9.863 22.936L152 114.13V120h5.788l82.98-.125c24.975-.495 47.397 6.348 67.468 20.932 20.642 14.998 34.281 35.124 39.568 59.958 6.682 31.384.591 60.327-19.817 85.83-16.681 20.845-38.538 32.792-64.233 38.29-4.463.955-9.168 1.045-13.764 1.069l-60.487.03c-22.531-.092-42.474-7.997-60.206-21.326-20.074-15.089-32.904-35.261-38.755-59.67-1.478-6.164-2.28-12.609-2.434-18.948-.352-14.462-.111-28.939-.111-43.798-1.899-.089-3.503-.229-5.108-.231-13.83-.017-27.668.274-41.489-.092-13.064-.346-27.555-8.859-30.806-23.018-4.603-20.044 7.855-38.166 29.033-38.805 15.94-.481 31.906-.095 48.369-.095v-7.275l.09-68.984c.21-14.336 7.699-27.491 22.995-31.704 11.131-3.065 21.724-1.206 31.132 6.673m29.236 238.369c7.674 5.35 16.224 7.139 25.502 6.991l47.968-.162c16.535-.435 28.806-8.482 37.045-22.755 4.499-7.793 4.244-16.366 4.022-24.917-.133-5.114.667-10.549-.789-15.274-3.439-11.158-12.607-18.803-25.69-18.887l-102.938-.063c-1.435.001-2.87.175-4.571.286l.075 37.765c.067 4.049.712 8.153 1.616 12.112 2.389 10.456 8.354 18.575 17.76 24.905z"
      />
    </svg>
  )
}
